import { render, staticRenderFns } from "./card-produtos-checkout.vue?vue&type=template&id=db8bb184&scoped=true"
import script from "./card-produtos-checkout.vue?vue&type=script&lang=js"
export * from "./card-produtos-checkout.vue?vue&type=script&lang=js"
import style0 from "./card-produtos-checkout.vue?vue&type=style&index=0&id=db8bb184&prod&lang=css"
import style1 from "./card-produtos-checkout.vue?vue&type=style&index=1&id=db8bb184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8bb184",
  null
  
)

export default component.exports